import { type IBridgeLinkProps } from '@webapp/core/components/BridgeLink'
import { BreadcrumbLinkStyled } from './styles/BreadcrumbLinkStyled'
import { formatCrumbName } from './utils'

export interface IBreadcrumbLinkProps extends IBridgeLinkProps {
  children: string
  escapeCaseFormatting?: boolean
}

export const BreadcrumbLink = ({
  children,
  escapeCaseFormatting,
  ...otherProps
}: IBreadcrumbLinkProps) => (
  <BreadcrumbLinkStyled {...otherProps}>
    {formatCrumbName(children, escapeCaseFormatting)}
  </BreadcrumbLinkStyled>
)

BreadcrumbLink.displayName = 'BreadcrumbLink'
